/**
 * Textos de Qualitat i APPCC (`en`): ajunta els fitxers de cada tall. Cablejat a `en.ts` amb un sol
 * `...qualityEn`; així cada tall edita només el seu fitxer.
 */

import { suppliersEn } from './suppliers.en.js';
import { trainingEn } from './training.en.js';
import { nonConformitiesEn } from './nonconformities.en.js';
import { selfChecksEn } from './selfchecks.en.js';
import { receptionEn } from './reception.en.js';
import { evidenceEn } from './evidence.en.js';
import { plantaEn } from './planta.en.js';

export const qualityEn = {
  ...suppliersEn,
  ...trainingEn,
  ...nonConformitiesEn,
  ...selfChecksEn,
  ...receptionEn,
  ...evidenceEn,
  ...plantaEn,
} as const;
